import React, { useState, useEffect } from "react";
import ExportApi from "../../api/ExportApi";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Seo() {
  const [page, setPage] = useState("");
  const [metaTitle, setMetaTitle] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [image, setImage] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);
  const [seoData, setSeoData] = useState([]);
  const [seoId, setSeoId] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);

  const pagesList = [
    "Home",
    "Categories",
    "UserBuySell",
    "About",
    "News",
    "Help",
  ];

  // Handle adding SEO data (multipart form data)
  const handleAddSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("page", page);
    formData.append("metaTitle", metaTitle);
    formData.append("metaDescription", metaDescription);
    if (image) formData.append("image", image); // Append image if available
    try {
      const response = await ExportApi.saveSeoData(formData); // Pass FormData as payload
      if (response?.data?.error === "SEO data already exists for this page") {
        toast.error(response?.data?.error);
        setIsUpdating(false);
        setShowAddModal(false);
        return;
      }
      toast.success(response.message || "SEO data saved successfully");
      setIsUpdating(false);
      fetchAllSeoData();
      setShowAddModal(false);
    } catch (err) {
      toast.error("Error saving SEO data");
    }
  };

  const handleUpdateSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("_id", seoId);
    formData.append("page", page);
    formData.append("metaTitle", metaTitle);
    formData.append("metaDescription", metaDescription);
    if (image) formData.append("image", image);
    try {
      const response = await ExportApi.updateseotags(formData);
      toast.success(response.message || "SEO data updated successfully");
      setIsUpdating(true);
      fetchAllSeoData();
      setShowUpdateModal(false);
    } catch (err) {
      toast.error("Error updating SEO data");
    }
  };

  const fetchAllSeoData = async () => {
    try {
      const resp = await ExportApi.getSeoDataall();
      setSeoData(resp?.data?.data);
    } catch (err) {
      toast.error("Error fetching SEO data");
    }
  };

  const handleDelete = async (id) => {
    try {
      const response = await ExportApi.deleteSeoData(id);
      toast.success(response.message || "SEO data deleted successfully");
      fetchAllSeoData();
    } catch (err) {
      toast.error("Error deleting SEO data");
    }
  };
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setPreviewImage(URL.createObjectURL(file));
    } else {
      setImage(null);
      setPreviewImage(null);
    }
  };

  useEffect(() => {
    fetchAllSeoData();
  }, []);

  return (
    <div>
      <div className="mt-3">
        <h2>SEO Configuration</h2>
        <button
          className="btn btn-primary mb-3"
          onClick={() => {
            setPage("");
            setMetaTitle("");
            setMetaDescription("");
            setImage(null); // Clear selected image
            setIsUpdating(false);
            setShowAddModal(true);
          }}
        >
          Add SEO Data
        </button>
      </div>

      {showAddModal && !isUpdating && (
        <div
          className="modal fade show"
          style={{ display: "block" }}
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add SEO Data</h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => setShowAddModal(false)}
                >
                  &times;
                </button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleAddSubmit}>
                  <div className="form-group">
                    <label htmlFor="page">Page:</label>
                    <select
                      id="page"
                      value={page}
                      onChange={(e) => setPage(e.target.value)}
                      required
                      className="form-control"
                    >
                      <option value="">-- Select a page --</option>
                      {pagesList.map((pageName, index) => (
                        <option key={index} value={pageName}>
                          {pageName}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label htmlFor="metaTitle">Meta Title:</label>
                    <input
                      type="text"
                      id="metaTitle"
                      value={metaTitle}
                      onChange={(e) => setMetaTitle(e.target.value)}
                      required
                      className="form-control"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="metaDescription">Meta Description:</label>
                    <textarea
                      id="metaDescription"
                      value={metaDescription}
                      onChange={(e) => setMetaDescription(e.target.value)}
                      required
                      className="form-control"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="image">Upload Image:</label>
                    <input
                      type="file"
                      id="image"
                      onChange={handleImageChange}
                      className="form-control"
                    />
                  </div>
                  <br></br>
                  <button type="submit" className="btn btn-primary">
                    Save SEO Data
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {showUpdateModal && isUpdating && (
        <div
          className="modal fade show"
          style={{ display: "block" }}
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Update SEO Data</h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => setShowUpdateModal(false)}
                >
                  &times;
                </button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleUpdateSubmit}>
                  <div className="form-group">
                    <label htmlFor="page">Page:</label>
                    <select
                      id="page"
                      value={page}
                      onChange={(e) => setPage(e.target.value)}
                      required
                      className="form-control"
                    >
                      <option value="">-- Select a page --</option>
                      {pagesList.map((pageName, index) => (
                        <option key={index} value={pageName}>
                          {pageName}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label htmlFor="metaTitle">Meta Title:</label>
                    <input
                      type="text"
                      id="metaTitle"
                      value={metaTitle}
                      onChange={(e) => setMetaTitle(e.target.value)}
                      required
                      className="form-control"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="metaDescription">Meta Description:</label>
                    <textarea
                      id="metaDescription"
                      value={metaDescription}
                      onChange={(e) => setMetaDescription(e.target.value)}
                      required
                      className="form-control"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="image">Update Image:</label>
                    <input
                      type="file"
                      id="image"
                      onChange={handleImageChange}
                      className="form-control"
                    />

                    {previewImage ? (
                      <img
                        src={previewImage}
                        alt="Preview"
                        style={{
                          height: "50px",
                          width: "50px",
                          objectFit: "cover",
                          marginTop: "15px",
                          marginLeft: "25px",
                        }}
                      />
                    ) : image ? (
                      <img
                        src={image}
                        alt="Previous Image"
                        style={{
                          height: "50px",
                          width: "50px",
                          objectFit: "cover",
                          marginTop: "15px",
                          marginLeft: "25px",
                        }}
                      />
                    ) : null}
                  </div>
                  <br></br>
                  <button type="submit" className="btn btn-primary">
                    Update SEO Data
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Table to display existing SEO data */}
      <h3 className="mt-4">All SEO Data</h3>
      <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th>Page</th>
              <th>Meta Title</th>
              <th>Meta Description</th>
              <th>Meta Images</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {seoData?.length === 0 ? (
              <tr>
                <td colSpan="5">No SEO data available</td>{" "}
                {/* Adjust colspan to 5 to match the number of columns */}
              </tr>
            ) : (
              seoData?.map((data, index) => (
                <tr key={index}>
                  <td style={{ width: "20%", height: "50px" }}>{data?.page}</td>
                  <td style={{ width: "25%" }}>
                    <textarea
                      style={{
                        width: "100%",
                        height: "70px",
                        overflow: "auto",
                        resize: "none", 
                        border: "none",
                        backgroundColor: "transparent",
                      }}
                      value={data?.metaTitle}
                      readOnly
                    />
                  </td>
                  <td style={{ width: "25%" }}>
                    <textarea
                      style={{
                        width: "100%",
                        height: "70px",
                        overflow: "auto",
                        resize: "none",
                        border: "none",
                        backgroundColor: "transparent",
                      }}
                      value={data?.metaDescription}
                      readOnly
                    />
                  </td>

                  <td>
                    {data?.metaImage ? (
                      <div
                        style={{
                          position: "relative",
                          display: "inline-block",
                        }}
                      >
                        <img
                          src={data?.metaImage}
                          alt="SEO Image"
                          style={{
                            height: "75px",
                            width: "75px",
                            objectFit: "cover",
                            cursor: "pointer",
                          }}
                          className="zoom-preview"
                        />
                        <div className="full-preview">
                          <img src={data?.metaImage} alt="Full Preview" />
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </td>
                  <td>
                    <button
                      className="btn btn-warning"
                      onClick={() => {
                        setPage(data?.page);
                        setMetaTitle(data?.metaTitle);
                        setMetaDescription(data?.metaDescription);
                        setSeoId(data?._id);
                        setPreviewImage(data?.metaImage);
                        setIsUpdating(true);
                        setShowUpdateModal(true); // Open the update modal
                      }}
                    >
                      Edit
                    </button>
                    &nbsp; &nbsp;
                    <button
                      className="btn btn-danger ml-2"
                      onClick={() => handleDelete(data?._id)} // Call delete function
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Seo;
